module.exports = __webpack_public_path__ + "static/media/3.d018c0b6.jpg";